var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb10" },
    [
      _c(
        "div",
        { staticClass: "mb10 feet-r" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v(_vm._s(_vm.$t("basicData.AddARow")))]
          ),
          _c("importAndDownloadCmp", {
            attrs: {
              "fee-type-list": _vm.feeTypeList,
              "stitching-line": _vm.stitchingLine,
              "model-list": _vm.modelList,
              "get-data-func": _vm.onDownloadOffer,
            },
            on: { importList: _vm.onImportList },
          }),
          _c(
            "el-popover",
            {
              attrs: { placement: "bottom-start", trigger: "hover" },
              scopedSlots: _vm._u([
                {
                  key: "reference",
                  fn: function () {
                    return [
                      _c("el-button", { attrs: { size: "small" } }, [
                        _vm._v(_vm._s(_vm.$t("basicData.ClearTheOffer"))),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "div",
                { staticClass: "feet" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "feet-btn",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.onClear },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("basicData.EmptyCurrentPartition")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "feet-btn",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.onAllClear },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("basicData.EmptyAllPartitions")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("TableCmp", {
        ref: "defaultTableRef",
        attrs: {
          "fee-type-list": _vm.feeTypeList,
          "model-list": _vm.modelList,
          "table-data": _vm.getPartitionArr,
        },
        on: { change: _vm.changePartition },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }